import { TradePairTag } from '@ui/constants/tokens/tradePairTags';
import { CategoryTag } from '@ui/features/MassiveToken/constants';
import { create } from 'zustand';

type Store = {
  currentCategory: CategoryTag;
  currentSubCategory: TradePairTag | null;
  setCategory: (
    category: CategoryTag,
    subCategory: TradePairTag | null,
  ) => void;
  setSubCategory: (subCategory: TradePairTag | null) => void;
};

export const useTabsStore = create<Store>((set) => ({
  currentCategory: CategoryTag.ALL,
  currentSubCategory: null,

  setCategory: (category, subCategory) => {
    set({
      currentCategory: category,
      currentSubCategory: subCategory,
    });
  },

  setSubCategory: (subCategory: TradePairTag | null) => {
    set({ currentSubCategory: subCategory });
  },
}));
